import CtaLink from './cta-link'
import { useTranslations } from '@/utils/locale'
import { SizeType } from './cta-link'
import { usePage } from '@inertiajs/react'
import { getPdfPath } from '@/utils/print.ts'

export default function DownloadPdfButton({
  buttonStyle,
  backgroundColor,
  btnText,
  className,
  size = 'Base',
  bgGradient = false,
}: {
  backgroundColor: string
  buttonStyle: string
  btnText: string
  className?: string
  size?: SizeType
  bgGradient?: boolean
}) {
  const { t } = useTranslations()

  const { url } = usePage()

  const pdfPath = getPdfPath(url)

  return (
    <a href={pdfPath} target="_blank">
      <CtaLink asButton className={className} style={buttonStyle} size={size} bgGradient={bgGradient}>
        <span className="font-bwi mr-2">&#xe94e;</span>
        {t(btnText)}
      </CtaLink>
    </a>
  )
}
